import React, {useRef} from "react";
import './styles.css'
import rootDir from "../..";
import { Link } from "react-router-dom";
import { useHeader } from "../../lib/varHeader";
import { useFilter } from "../../lib/varFilter";


const NavBar = () => {
    const { header } = useHeader();
    const { filter } = useFilter();
    const pageRef = useRef<HTMLInputElement>(null);
    let maxPage: number;
    let curPage: number;
    let loadPage: number;
    header.max_page ? maxPage = header.max_page : maxPage = 1
    header.current_loaded_page ? loadPage = header.current_loaded_page : loadPage = -1
    header.current_list_page ? curPage = header.current_list_page : curPage = 0
    function handlePager() {
        // return
    }
    return (
        <div className="main">
            <Link to={rootDir+'page/1'}><button
                className="navButton"
                title="1"
            >|&lt;</button></Link>
            <Link to={rootDir+'page/'+Math.max(curPage-1,1).toString(10)}><button
                className="navButton"
                title={Math.max(curPage-1,1).toString(10)}
            >&lt;&lt;</button></Link>
            &nbsp;&hellip;&nbsp;
            <input 
                className="nav_page_box" 
                type="text"
                ref={pageRef} 
                min={1} 
                max={maxPage} 
                value={curPage}
                // onChange={(e) => handlePager(e.target.value)}
                readOnly
            />
            &nbsp;of&nbsp;
            <input className="nav_page_box" type="text" value={maxPage} readOnly />
            &nbsp;&hellip;&nbsp;
            <Link to={rootDir+'page/'+Math.min(maxPage,curPage+1).toString(10)}><button
                className="navButton"
                title={Math.min(maxPage,curPage+1).toString(10)}
            >&gt;&gt;</button></Link>
            <Link to={rootDir+'page/'+maxPage.toString(10)}><button
                className="navButton"
                title={maxPage.toString(10)}
            >&gt;|</button></Link>
            {curPage === loadPage || loadPage === 0 ? null : <img src={rootDir+"img/load.gif"} alt="Loading..." height={25} />}
        </div>
    );
}

export default NavBar